import React, {useState} from 'react';

import DomainTablePage from '../../components/domainTablePage.js'
import {TagWebsitesPageResult} from '../../../../server/routes/tag.js'


interface TAGWebsitesProps {
	server: string;
	pageData: unknown;
}

export default function TAGWebsites({server, pageData}: TAGWebsitesProps) {

	const typedPageData = pageData as TagWebsitesPageResult;
	const [data, setData] = useState(typedPageData);

	return (
        <DomainTablePage 
            domainList={data.TechnologyDomains}
        />
	)
}
